<script setup>
    import { ref, onMounted } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { EffectFade, Navigation, Pagination, A11y } from 'swiper';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';
    import 'swiper/css/effect-fade';

    const props   = defineProps({ slides: Object })
    const modules = [EffectFade, Navigation, Pagination, A11y]

    const speed = ref(300)

    onMounted(() => {
        if (window?.reduced_motion) {
            speed.value = 0;
        }
    })

    function onSwiper(swiper) {
        console.log(swiper)
    }
    function onSlideChange() {
        console.log('slide change')
    }
</script>

<template>
    <swiper
        :modules="modules"
        :slides-per-view="1"
        :loop="true"
        :speed="speed"
        :effect="'fade'"
        :fadeEffect="{ crossFade: true }"
        :navigation="true"
        :pagination="{ clickable: true }"
        class="carousel-gallery"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
    >
        <swiper-slide v-for="slide in props.slides">
            <div class="slide w-full flex items-start relative">
                <div class="image-feature w-full relative overflow-hidden">
                    <img class="absolute w-full h-full object-cover top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" :src="slide.image_url" :alt="slide.image_alt">
                </div>
                <div class="absolute right-0 bottom-0 left-0 text-white">
                    <div class="bg-theme-grey-dark opacity-50 absolute inset-0"></div>
                    <div class="w-10/12 mx-auto py-8 relative z-[1]">
                        <h3 class="mt-0 font-bold" v-if="slide.title">{{ slide.title }}</h3>
                        <div v-if="slide.text" class="rich-text-body text-sm md:text-base max-w-[500px]" v-html="slide.text"></div>
                        <a v-if="slide.link" class="theme-button mt-8" :href="slide.link">{{ slide.link_text }}</a>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>
